// extracted by mini-css-extract-plugin
module.exports = {"signupPage":"page_signupPage__aCRus","mainContent":"page_mainContent__ty9jP","title":"page_title__wf_DR"};